import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        avatar: '',
        userId: '',
        productId: "",
				navList: [],
				permissions: [],
				visitedViews: [],
				msgReadStatus: 2, // 新消息读取状态，默认2未读,1已读
				isCollapseStatus: false,
    },
    getters: {
        getAvatar(state) {
            return state.avatar
        },
        userId(state) {
            return state.userId
        },
        productId(state) {
            return state.productId
        },
				getNavList(state) {
					return state.navList
				},
				getPermissions(state){
					return state.permissions
				},
				getVisitedViews(state){
					return state.visitedViews
				},
				getMsgReadStatus(state){
					return state.msgReadStatus
				},
				getIsCollapseStatus(state){
					return state.isCollapseStatus
				}
    },
    mutations: {
        // 改变头像
        changeAvatar(state, avatar) {
            state.avatar = avatar;
        },
				// 改变导航数组
				changeNavList(state, list) {
				  state.navList = list;
				},
				changePermissions(state, list){
					state.permissions = list;
				},
				// 面包屑替换
				changeVisitedViews(state, list){
					state.visitedViews = list
					// localStorage.removeItem('sdk-visitedViews');
					// localStorage.setItem('sdk-visitedViews',JSON.stringify(state.visitedViews));
				},
				// 面包关闭其他
				closeVisitedViewsOther(state, obj){
					state.visitedViews = []
					state.visitedViews.push(obj);
					localStorage.removeItem('sdk-visitedViews');
					localStorage.setItem('sdk-visitedViews',JSON.stringify(state.visitedViews));
				},
				// 面包关闭全部
				closeAllVisitedViews(state){
					state.visitedViews = []
					localStorage.removeItem('sdk-visitedViews');
				},
				// 面包屑添加
				addVisitedViews(state, obj){
					let checked = state.visitedViews.some((item) => item.path === obj.path);
					if (!checked) {
						state.visitedViews.push(obj);
						localStorage.removeItem('sdk-visitedViews');
						localStorage.setItem('sdk-visitedViews',JSON.stringify(state.visitedViews));
					}
				},
				// 面包屑删除
				deleteVisitedViews(state, index){
					state.visitedViews.splice(index,1);
					localStorage.removeItem('sdk-visitedViews');
					localStorage.setItem('sdk-visitedViews',JSON.stringify(state.visitedViews));
				},
				// 修改消息读取状态
				changeReadStatus(state, status){
					state.msgReadStatus = status
				},
				// 修改侧导航折叠状态
				changeMenuStatus(state, status){
					state.isCollapseStatus = status
				},
        getUserId(state, userId) { //用户iD
            state.userId = userId
        },
        getProductId(state, productId) { //产品iD
            state.productId = productId
        }
    },
    actions: {},
    modules: {}
})